// extracted by css-extract-rspack-plugin
export default {"card":"MLcR9","active":"lcwEV","link":"PBYD3","icon":"Kmsj2","input":"BoNsI","description":"hpJmD","name":"c83jN"};